import { isNil, unzip, isEmpty } from 'lodash/fp';

export const mergeQuery = (queries, metadata) =>
    isNil(metadata) ? null : { ...metadata, ...queries[metadata.queryId] };

export const rowsToColumns = (d) => ({
    schema: { columns: d.columns },
    columns: unzip(d.records),
    rowCount: d.rowCount ?? d.records.length
});

export const extractRowCountFromLastColumn = (d) => {
    // temporary guard to not break any cached results
    // will be removed.
    if (d.columns[d.columns.length - 1]?.name !== 'COUNT(0) OVER ()') {
        return d;
    }

    return {
        columns: d.columns.slice(0, -1),
        records: d.records.map((r) => r.slice(0, -1)),
        rowCount: isEmpty(d.records) ? 0 : d.records[0][d.records[0].length - 1]
    };
};

export const parseKey = (k) =>
    Array.isArray(k) ? k : k.match(/([^[\].]+)|\[(.*?)\]/g).map((p) => p.replaceAll(/[[\]']/g, ''));

export const ensurePathExists = (object, parts) => {
    let o = object;

    for (const k of parts) {
        if (!o.hasOwnProperty(k)) {
            o[k] = {};
        }

        o = o[k];
    }
};

export const deletePath = (object, parts) => {
    let o = object;

    for (const k of parts.slice(0, -1)) {
        if (!o.hasOwnProperty(k)) {
            return;
        }

        o = o[k];
    }

    delete o[parts.slice(-1)];
};

export function previewSql(sql) {
    const withRowCount = sql.replace(/SELECT (.*) FROM/, 'SELECT $1, COUNT(0) OVER () FROM');
    return withRowCount;
}
